<template>
  <div style="position: relative;">
    <n-icon
      name="dots-horizontal"
      color="grey-dark"
      @click="visible = !visible"
    />
    <div
      v-if="visible"
      class="popover-background"
      @click.stop="closePopover"
    />
    <div
      v-if="visible"
      class="popover-menu"
    >
      <slot :close-popover="closePopover" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false
    };
  },
  methods: {
    closePopover(callback = null) {
      this.visible = false;
      this.$emit('close');
      if (callback && typeof callback === 'function') {
        callback();
      }
    }
  }
};
</script>
<style scoped>
.popover-background {
  background: #00000040;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  z-index: 10;
}

.popover-menu {
  position: absolute;
  left: -225px;
  width:250px;
  top: 30px;
  box-shadow: 0px 2px 2px 0px #0000001A;
  border-radius: 10px;
  background-color: white;
  z-index: 11;
  overflow: hidden;
}

.popover-menu-item {
  display: flex;
  align-items: center;
  padding: 14px 10px;
}

.popover-menu-item:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-200);
}

.popover-menu-item:hover {
  background-color: var(--color-blue-50);
}

.popover-menu-item .icon-wrapper {
  margin-right: 20px;
}
</style>